export const randomUUID = () => {
    return (
      Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1) +
      Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1)
    );
  };